<template>
  <div v-if="applicantApplicationsPage" id="applicant-edit-tab-personal-data">
    <vs-table
      v-if="
        applicantApplicationsPage && applicantApplicationsPage.results.length
      "
      :data="applicantApplicationsPage.results"
    >
      <template slot="thead">
        <vs-th>Stelle</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Nachricht</vs-th>
        <vs-th>Datum</vs-th>
        <vs-th />
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="entry in data" :key="entry.id" :data="entry">
          <vs-td>
            <template v-if="entry.project">
              <router-link
                :to="{
                  name: 'project.edit',
                  params: { id: entry.project.id }
                }"
              >
                {{ entry.project.number }} - {{ entry.project.title }}
              </router-link>
            </template>
            <template v-if="entry.vacancy">
              {{
                entry.project
                  ? `(${entry.vacancy.number})`
                  : entry.vacancy.number
              }}
              -
              {{
                entry.project ? `(${entry.vacancy.title})` : entry.vacancy.title
              }}
            </template>
          </vs-td>

          <vs-td>
            {{ entry.state && entry.state.name ? entry.state.name : "-" }}
          </vs-td>

          <vs-td>
            {{ entry.message }}
          </vs-td>

          <vs-td>
            {{ $d(new Date(entry.createdAt), "long") }}
          </vs-td>
          <vs-td>
            <vs-button
              v-if="entry.isManual"
              @click="confirmDeleteRecord(entry.id)"
            >
              <i class="far fa-trash" />
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-else>Keine Stellen zugewiesen</div>
    <AddVacancy
      :applicant-i-d="this.$route.params.id"
      @applicantVacanciesChanged="refetchVacancies()"
    />
  </div>
</template>

<script>
import gql from "graphql-tag";
import AddVacancy from "@/components/applicant/AddVacancy";

export default {
  components: {
    AddVacancy
  },
  props: {
    profileId: { type: String, required: true }
  },
  data() {
    return {
      saveInterval: null,
      fetchFailed: false,
      deleteId: null
    };
  },
  apollo: {
    applicantApplicationsPage: {
      query: gql`
        query ApplicantApplicationsPage($applicant: ID!, $page: Int) {
          applicantApplicationsPage(applicant: $applicant, page: $page) {
            results {
              id
              project {
                id
                number
                title
              }
              vacancy {
                id
                number
                title
              }
              state {
                id
                name
              }
              message
              createdAt
              isManual
            }
            total
          }
        }
      `,
      variables() {
        return {
          applicant: this.$route.params.id,
          page: 1
        };
      }
    }
  },
  computed: {
    profile: {
      get() {
        return this.applicantProfile;
      },
      // eslint-disable-next-line
      set(v) {
        this.save(false);
      }
    }
  },
  watch: {
    profile: {
      deep: true,
      handler(v) {
        this.profile = v;
      }
    }
  },
  methods: {
    updateValue() {
      this.profile = this.applicantProfile;
    },
    refetchVacancies() {
      this.$apollo.queries["applicantApplicationsPage"].refetch();
    },
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Stellen Zuordnung zu löschen. Bist du sicher?`,
        accept: this.deleteRecord,
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($applicantId: ID!, $applicationId: ID!) {
              removeApplication(
                applicantId: $applicantId
                applicationId: $applicationId
              ) {
                id
              }
            }
          `,
          variables: {
            applicationId: this.deleteId,
            applicantId: this.$route.params.id
          }
        })
        .then(() => {
          this.refetchVacancies();
        });
    }
  }
};
</script>
